import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api } from '@/api/client'

type BrandingResponse = {
  app_name: string
  logo_url: string | null
  icon_url: string | null
  favicon_url: string | null
}

export const useBrandingStore = defineStore('branding', () => {
  const appName = ref('Envoy')
  const logoUrl = ref<string | null>(null)
  const iconUrl = ref<string | null>(null)
  const faviconUrl = ref<string | null>(null)
  const loaded = ref(false)

  const initial = computed(() => appName.value.charAt(0).toUpperCase())

  function applyFavicon(url: string | null) {
    if (!url) return
    const link = document.getElementById('app-favicon') as HTMLLinkElement | null
    if (link) link.href = url
  }

  async function fetch(opts?: { force?: boolean }) {
    if (loaded.value && !opts?.force) return
    try {
      const data = await api.get<BrandingResponse>('/branding')
      appName.value = data.app_name
      logoUrl.value = data.logo_url
      iconUrl.value = data.icon_url
      faviconUrl.value = data.favicon_url
    } catch {
      // fallback to defaults
    }
    loaded.value = true
    document.title = appName.value
    applyFavicon(faviconUrl.value)
  }

  return { appName, logoUrl, iconUrl, faviconUrl, initial, loaded, fetch }
})
